import {
  CREDITOPTION_LOADING,
  GET_CREDITOPTION,
  GET_CREDITOPTION_SUCCESS,
  GET_CREDITOPTION_FAIL,
  ADD_CREDITOPTION_SUCCESS,
  ADD_CREDITOPTION_FAIL,
  DELETE_CREDITOPTION_SUCCESS,
  DELETE_CREDITOPTION_FAIL,
  UPDATE_CREDITOPTION_SUCCESS,
  UPDATE_CREDITOPTION_FAIL,
  CREDITOPTION_RESET
} from "./actionType";

const INIT_STATE = {
  creditOptions: [],
  error: {},
};

const CreditOption = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CREDITOPTION_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CREDITOPTION:
          return {
            ...state,
            creditOptions: action.payload.data,
            isCreditOptionCreated: false,
            isCreditOptionSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_CREDITOPTION_FAIL:
      switch (action.payload.actionType) {
        case GET_CREDITOPTION_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isCreditOptionCreated: false,
            isCreditOptionSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_CREDITOPTION: {
      return {
        ...state,
        isCreditOptionCreated: false,
        loading: true,
      };
    }

    case CREDITOPTION_LOADING: {
      return {
        ...state,
        isCreditOptionCreated: false,
        loading: true,
      };
    }

    case ADD_CREDITOPTION_SUCCESS:
      return {
        ...state,
        isCreditOptionCreated: true,
        loading: false,
        creditOptions: [action.payload.data, ...state.creditOptions],
      };

    case ADD_CREDITOPTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_CREDITOPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        isCreditOptionCreated: true,
        creditOptions: state.creditOptions.filter(
          creditOption => creditOption.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_CREDITOPTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_CREDITOPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        isCreditOptionCreated: true,
        creditOptions: state.creditOptions.map(creditOption =>
          creditOption.id.toString() === action.payload.data.id.toString() ? { ...creditOption, ...action.payload.data } : creditOption
        ),
      };

    case UPDATE_CREDITOPTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CREDITOPTION_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default CreditOption;